module.exports = __webpack_public_path__ + "media/images/logo-2749bb8cf1051a9ceea0eaeb8c5aaf22.png";